// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/cog.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/cog'

import { Icon, type IconComponentProps } from '../icon'

export const CogIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
